import React, { useState } from 'react';
import onClickOutside from 'react-onclickoutside';
import { Link } from "react-router-dom";

const LeftMenuMobile = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const [width, setWidth] = React.useState(window.innerWidth);

    LeftMenuMobile.handleClickOutside = () => setIsOpen(false);

    React.useEffect(() => {
        /* Inside of a "useEffect" hook add an event listener that updates
           the "width" state variable when the window size changes */
        window.addEventListener("resize", () => setWidth(window.innerWidth));
    
        /* passing an empty array as the dependencies of the effect will cause this
           effect to only run when the component mounts, and not each time it updates.
           We only want the listener to be added once */
    }, []);

    var leftMenuVisibleClass = '';
    if (isOpen && width <= 991) {
        leftMenuVisibleClass = 'show';
    }
    var orderAdherenceHeaderClass = '';
    if(props.breakdownClass =='' && props.trendsClass =='' && props.detailsClass =='') {
        orderAdherenceHeaderClass = 'active';
    }


    return (
        <div>
            <div className={`left-dashboard-desktop-menu ${leftMenuVisibleClass}`}>
                <ul>
                    {/* <li style={{ cursor: 'pointer' }} onClick={toggle} className="close-icon-left"><img src="/images/cancel.png"></img></li> */}
                    <li className={orderAdherenceHeaderClass}><a href="#" role="button">{props.isPapUser == 0 ? 'Orders' : 'Orders and Adherence'}</a></li>
                    {
                        props.isScrrenedPatientPage == 'true' &&
                        <>
                        {props.isPapUser == 1 &&
                            <ul className="orderadherence-submenu">
                                <li class={props.breakdownClass}><a onClick={() => props.scrollToBreakDown('breakdown')} href="javascript:void(0)" class={props.breakdownClass}>Breakdowns</a></li>
                                <li class={props.trendsClass}><a onClick={() => props.scrollToBreakDown('trends')} href="javascript:void(0)" class={props.trendsClass}>Trends</a></li>
                                <li  class={props.detailsClass}><a onClick={() => props.scrollToBreakDown('details')} href="javascript:void(0)" class={props.detailsClass}>Details</a></li>
                            </ul>
                        }
                        {props.isPapUser == 0 &&
                            <ul className="orderadherence-submenu">
                                <li  class={props.breakdownClass}><a onClick={() => props.scrollToBreakDown('breakdown')} href="javascript:void(0)" class={props.breakdownClass}>Breakdown and Trends</a></li>
                                <li class={props.detailsClass}><a onClick={() => props.scrollToBreakDown('details')} href="javascript:void(0)" class={props.detailsClass}>Details</a></li>
                            </ul>
                        }
                        </>
                    }
                    {(props.globalSummaryAccess == 1) && <li style={{ fontWeight: 'normal' }}>Global Summary</li>}
                    {(props.sleepScreenerAccess != 0) && <li style={{ fontWeight: 'normal' }}><Link to="/screened-patient">Screened Patients </Link></li>}
                </ul>
            </div>
            <div style={{ cursor: 'pointer' }} onClick={toggle} className="mobile-menu-dashboard">
                <img src="/images/hambuger.png" />
            </div>
        </div>
    );
};

const clickOutsideConfig = {
    handleClickOutside: () => LeftMenuMobile.handleClickOutside
};

export default onClickOutside(LeftMenuMobile, clickOutsideConfig);
